// Shared by the change-request page and its detail dialog.
export const STATUS_COLOR = { pending: "warning", approved: "success", rejected: "error" };

export const statusKey = (s) => `packageChangeRequest.status${s.charAt(0).toUpperCase()}${s.slice(1)}`;

export const fmtDate = (d) =>
  d ? new Date(d).toLocaleString(undefined, { year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" }) : "—";

// Cancel requests store Package.cancelReason's category key in `reason` —
// same labels as scenes/packages/packageList.jsx.
export const CANCEL_REASON_LABEL_KEYS = {
  customer_request: "packages.cancel.reasonCustomerRequest",
  no_pickup: "packages.cancel.reasonNoPickup",
  duplicate: "packages.cancel.reasonDuplicate",
  undeliverable: "packages.cancel.reasonUndeliverable",
  other: "packages.cancel.reasonOther",
};
